import React from "react";
import { WrapTextNodesProps } from "./WrapTextNodes.types";
import Text from "../../atoms/Text";

/**
 * Wraps string and number children in a <Text> component.
 */
export const WrapTextNodes: React.FC<WrapTextNodesProps> = (props) => {
  const { children, ...textProps } = props;
  return (
    <>
      {React.Children.map(children, (child) =>
        typeof child === 'string' || typeof child === 'number' ? (
          <Text {...textProps}>
            {child}
          </Text>
        ) : (
          child
        )
      )}
    </>
  );
};
